import React from 'react'

export default function LossHistoryPage() {
  return (
    <div>
      wefewfe
    </div>
  )
}
